import { Box, Paper, Stack, SvgIcon, Typography, useTheme, useMediaQuery } from "@mui/material";
import { cl } from "./About.styles";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ABOUT_US_BLOCK_DATA } from "./About.constants";

const imageVariants = {
  enter: { opacity: 0, y: 20 },
  center: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

//export const About = () => {
//  return (
//    <Stack sx={cl.root} id="about">
//      <Stack sx={cl.textContainer}>
//        <Typography variant="caption" sx={cl.captureText}>
//          {ABOUT_US_BLOCK_DATA.captureText}
//        </Typography>
//        <Typography variant="h2" sx={cl.title}>
//          {ABOUT_US_BLOCK_DATA.title}
//        </Typography>
//        <Typography variant="h5" sx={cl.subtitle}>
//          {ABOUT_US_BLOCK_DATA.subtitle}
//        </Typography>
//        <Stack sx={cl.description}>
//          {ABOUT_US_BLOCK_DATA.description.map((item, index) => (
//            <Typography key={index} sx={cl.descriptionItem}>
//              {item}
//            </Typography>
//          ))}
//        </Stack>
//      </Stack>
//      <Stack sx={cl.imageContainer}>
//        <Box component="img" sx={cl.image} src={AboutUsImage} alt="about-us-image" />
//      </Stack>
//    </Stack>
//  );
//};

export const About = () => {
  const [activeId, setActiveId] = useState(ABOUT_US_BLOCK_DATA[0].id);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const activeCard = ABOUT_US_BLOCK_DATA.find((c) => c.id === activeId);
  const sharedBg = theme.palette.grey[100];
  const hoverBg = theme.palette.primary.light;

  const imageDisplay = (
    <Box sx={cl.imageContainer}>
      <AnimatePresence mode="wait">
        <motion.img
          key={activeCard.id}
          src={activeCard.img}
          alt={activeCard.title}
          initial="enter"
          animate="center"
          exit="exit"
          variants={imageVariants}
          transition={{ duration: 0.4 }}
          style={cl.image(isMobile)}
          draggable={false}
        />
      </AnimatePresence>
    </Box>
  );

  return (
    <Stack sx={cl.root} id="about">
      <Stack
        direction={isMobile ? "column" : "row"}
        spacing={isMobile ? 2 : 2}
        useFlexGap
        flexWrap="wrap"
        justifyContent="center"
        sx={cl.cardsContainer}
      >
        {isMobile && imageDisplay}

        {ABOUT_US_BLOCK_DATA.map(({ id, title, subtitle, Icon, color }) => {
          const isActive = id === activeId;

          return (
            <Paper
              key={id}
              onClick={() => setActiveId(id)}
              onMouseEnter={() => !isMobile && setActiveId(id)}
              elevation={isActive ? 6 : 1}
              sx={cl.card(isMobile, isActive, hoverBg, sharedBg)}
            >
              <Box sx={cl.iconContainer(isMobile, color)}>
                <SvgIcon component={Icon} sx={cl.icon(isMobile)} />
              </Box>
              <Box sx={cl.cardContent}>
                <Typography
                  variant={isMobile ? "subtitle2" : "subtitle1"}
                  fontWeight={600}
                  sx={cl.cardTitle(isMobile)}
                >
                  {title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {subtitle}
                </Typography>
              </Box>
            </Paper>
          );
        })}
      </Stack>

      {/* Image Display */}
      {!isMobile && imageDisplay}
    </Stack>
  );
};
